__turbopack_context__.v({
  "brand": "UgPx4q_brand",
  "partnership": "UgPx4q_partnership",
});
